// extracted by mini-css-extract-plugin
export var navbarSubLink = "M_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "M_wJ d_f0 d_dB";
export var subPageLink = "M_gf d_gf";
export var burger = "M_wM";
export var sublinkSize = "M_wN";
export var linkSize = "M_wP";
export var Link = "M_vg z_vg z_tB z_tW";